function isConsentGranted(category: string): boolean {
    const settings = useCookieSettingsCookie().value as Record<string, string> | null

    return settings?.[category] === 'granted'
}

/**
 * Reads a consent category from the persisted cookie settings
 * (`pilulkaCookieSettings`, managed by the cookie bar). Returns true only when
 * the user has explicitly granted it — the default is denied (opt-in).
 */
export function isAnalyticsConsentGranted(): boolean {
    return isConsentGranted('analytics_storage')
}

export function isFunctionalityConsentGranted(): boolean {
    return isConsentGranted('functionality_storage')
}

export function isAdvertisingConsentGranted(): boolean {
    return isConsentGranted('ad_storage')
}

/**
 * Reactive, app-wide mirror of the advertising (`ad_storage`) consent. Unlike the
 * one-shot `isAdvertisingConsentGranted()`, this shared state updates the instant the
 * cookie bar persists a new choice, so consumers react without a page refresh — e.g. the
 * layout's `useHead`, which then injects the Perselio/zoe script immediately on grant.
 * Seeded once (per request/hydration) from the persisted cookie; the cookie bar keeps it
 * in sync via `setAdvertisingConsentGranted()`.
 */
export function useAdvertisingConsentGranted() {
    return useState<boolean>('advertisingConsentGranted', () => isAdvertisingConsentGranted())
}

export function setAdvertisingConsentGranted(granted: boolean): void {
    useAdvertisingConsentGranted().value = granted
}
